import { withBasePath } from "@/lib/base-path";
import { browserCmw } from "@/lib/ky/browser";
import type { AccountType, AuthIntent } from "cmw-client";

type GoogleSignInButtonProps = {
  accountType: AccountType;
  intent: AuthIntent;
  label?: string;
  invitation?: string;
};

export function GoogleSignInButton({
  accountType,
  intent,
  label = "Sign in with Google",
  invitation,
}: GoogleSignInButtonProps) {
  const { auth, invitations } = browserCmw;

  return (
    <a
    role="button"
    onClick={(e)=>{
      e.preventDefault();
      const url = invitation
        ? invitations.googleAuthUrl(invitation)
        : auth.getAuthenticationUrl({ accountType, intent });

      url.then((data)=>{
        window.location.href = data.url;
      });
    }}
    className="inline-flex cursor-pointer h-62 w-full items-center justify-center gap-8 rounded-medium bg-brand-dark-blue px-32 text-18 font-semibold text-neutral-white transition-colors hover:bg-[#003350]"
    >
      <img src={withBasePath("/google-icon.svg")} alt="" width={20} height={20} className="size-20 shrink-0" />
      {label}
    </a>
  );
}
